import translationEn from './locales/en/translation.json'
import translationFi from './locales/fi/translation.json'

export const resources = {
  en: {
    translation: translationEn,
  },
  fi: {
    translation: translationFi,
  },
}

const localizationResources = {
  resources,
  supportedLanguages: Object.getOwnPropertyNames(resources),
}

export default localizationResources
